import _regenerator from "/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.to-string.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import store from '@/store';
import GridItem from '@/components/layout/GridItem.vue';
import PlatformCardSelectable from '@/components/platform/PlatformCardSelectable.vue';
import GridSquareLayout from '@/components/layout/GridSquareLayout.vue';
import { COPY_SPEACH_DEST_PLATFORM_SEARCH_FILTER, COPY_SPEACH_SOURCE_PLATFORM_SEARCH_FILTER, SEARCH_COPY_SPEACH_DEST_PLATFORMS, SEARCH_COPY_SPEACH_SOURCE_PLATFORMS, SETTINGS_LIST } from '@/store/actions/platforms';
import WSearchBar from "@/components/wrapper/w-search-bar.vue";
import { PlatformsSortEnum } from "@/store/enums/PlatformsSortEnum";
import { SortOrderEnum } from "@/store/enums/SortOrderEnum";
import ErrorDialog from '@/components/dialog/ErrorDialog.vue';
var ChoosePlatform = /*#__PURE__*/function (_Vue) {
  function ChoosePlatform() {
    var _this;
    _classCallCheck(this, ChoosePlatform);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ChoosePlatform, [].concat(args));
    _defineProperty(_this, "selectedPlatform", void 0);
    _defineProperty(_this, "excludedPlatform", void 0);
    _defineProperty(_this, "isSource", void 0);
    _defineProperty(_this, "copySpeachNotEligiblePlatform", null);
    _defineProperty(_this, "errorMsg", '');
    _defineProperty(_this, "dispatchType", void 0);
    _defineProperty(_this, "searchFilterDispatchType", void 0);
    return _this;
  }
  _inherits(ChoosePlatform, _Vue);
  return _createClass(ChoosePlatform, [{
    key: "mounted",
    value: function mounted() {
      var _Object$values;
      this.dispatchType = this.isSource ? SEARCH_COPY_SPEACH_SOURCE_PLATFORMS : SEARCH_COPY_SPEACH_DEST_PLATFORMS;
      this.searchFilterDispatchType = this.isSource ? COPY_SPEACH_SOURCE_PLATFORM_SEARCH_FILTER : COPY_SPEACH_DEST_PLATFORM_SEARCH_FILTER;
      if (!((_Object$values = Object.values(this.platforms)) !== null && _Object$values !== void 0 && _Object$values.length)) {
        this.searchPlatforms();
      }
    }
  }, {
    key: "platforms",
    get: function get() {
      return this.isSource ? store.getters.copySpeachSourcePlatforms : store.getters.copySpeachDestPlatforms;
    }
  }, {
    key: "platformFilter",
    get: function get() {
      return this.isSource ? store.getters.copySpeachSourcePlatformSearchFilter : store.getters.copySpeachDestPlatformSearchFilter;
    }
  }, {
    key: "onSearchInputUpdate",
    value: function () {
      var _onSearchInputUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(searchValue) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return store.dispatch(this.searchFilterDispatchType, searchValue);
            case 1:
              this.searchPlatforms(searchValue);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function onSearchInputUpdate(_x) {
        return _onSearchInputUpdate.apply(this, arguments);
      }
      return onSearchInputUpdate;
    }()
  }, {
    key: "searchPlatforms",
    value: function searchPlatforms(searchValue) {
      var _this2 = this;
      var searchCriteria = {
        sortBy: PlatformsSortEnum.NAME,
        sortOrder: SortOrderEnum.ASC
      };
      if (searchValue) {
        searchCriteria.platformName = searchValue;
      }
      this.errorMsg = '';
      store.dispatch(this.dispatchType, searchCriteria).then().catch(function (err) {
        _this2.errorMsg = err === null || err === void 0 ? void 0 : err.toString();
      });
    }
    // -- CUSTOM FUNCTIONS
  }, {
    key: "togglePlateforme",
    value: function togglePlateforme(platform) {
      var _this3 = this;
      if (this.excludedPlatform !== platform.platformID) {
        var _this$selectedPlatfor;
        if (((_this$selectedPlatfor = this.selectedPlatform) === null || _this$selectedPlatfor === void 0 ? void 0 : _this$selectedPlatfor.platformID) !== platform.platformID) {
          if (this.settingsPlatform(platform.platformID)) {
            this.checkSettingCopySpeach(platform);
          } else {
            store.dispatch(SETTINGS_LIST, platform).then(function () {
              return _this3.checkSettingCopySpeach(platform);
            });
          }
        } else {
          this.$emit('selected', null);
        }
      }
    }
  }, {
    key: "checkSettingCopySpeach",
    value: function checkSettingCopySpeach(platform) {
      if (this.settingsPlatform(platform.platformID).COPY_SPEACH_ENABLED) {
        this.$emit('selected', platform);
      } else {
        this.copySpeachNotEligiblePlatform = platform;
      }
    }
  }, {
    key: "settingsPlatform",
    value: function settingsPlatform(platformID) {
      return store.getters.settings(platformID);
    }
  }]);
}(Vue);
__decorate([Prop({
  default: null
})], ChoosePlatform.prototype, "selectedPlatform", void 0);
__decorate([Prop({
  default: ''
})], ChoosePlatform.prototype, "excludedPlatform", void 0);
__decorate([Prop()], ChoosePlatform.prototype, "isSource", void 0);
ChoosePlatform = __decorate([Options({
  components: {
    GridSquareLayout: GridSquareLayout,
    GridItem: GridItem,
    PlatformCardSelectable: PlatformCardSelectable,
    WSearchBar: WSearchBar,
    AlertDialog: ErrorDialog
  }
})], ChoosePlatform);
export default ChoosePlatform;